<template>
<b-row>
  <b-col md="6" sm="12">
    <b-form-group>
      <label>{{$t('views.log.list.table.createdAt') + ' '
              + $t('global.smFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.log.list.table.createdAt') + ' '
                                  + $t('global.smFrom')"
                            v-model.lazy="filters['createdAt[after]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col md="6" sm="12">
    <b-form-group>
      <label>{{$t('views.log.list.table.createdAt')  + ' '
            + $t('global.smTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.log.list.table.createdAt')  + ' '
                                  + $t('global.smTo')"
                            v-model.lazy="filters['createdAt[before]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
</b-row>
</template>

<script>
import addParamsToQuery from '@/utils/addParamsToQuery'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'

export default {
  name: 'LogFiltering',
  components: {
    VueCtkDateTimePicker
  },
  data () {
    return {
      delay: 500,
      filters: {
        'createdAt[after]': '',
        'createdAt[before]': ''
      }
    }
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'logs'
        this.getPage(addParamsToQuery(url, this.filters))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    }
  },
  directives: {
    debounce
  }
}
</script>

<style scoped>

</style>
